import BannerView from './BannerView';
export default BannerView;
